import React from 'react';
import { IncidentAnalysis } from '../../types/incident';

interface AssignmentTimelineProps {
    analysis: IncidentAnalysis;
}

const AssignmentTimeline: React.FC<AssignmentTimelineProps> = ({ analysis }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {analysis.assigned_to && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Assignment</h4>
                    <div className="p-3 bg-blue-50 rounded-md">
                        <h5 className="font-medium text-blue-900 mb-1">Assigned To</h5>
                        <p className="text-blue-800">{analysis.assigned_to}</p>
                    </div>
                </div>
            )}

            {analysis.estimated_resolution_time && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h4 className="font-medium text-gray-900 mb-4">Timeline</h4>
                    <div className="p-3 bg-yellow-50 rounded-md">
                        <h5 className="font-medium text-yellow-900 mb-1">Estimated Resolution</h5>
                        <p className="text-yellow-800">{analysis.estimated_resolution_time}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssignmentTimeline;
